import React from 'react';
import clsx from 'clsx';
import { PLAYWRIGHT_IGNORE } from '@/lib/constants';
import { NetflixLogo, TableauLogo } from '@/components/Logos';
import LogoTile from '@/sections/customers/FeaturedStoriesSection/LogoTile';

interface SelectLogoTilesProps {
  handleSelectStory: (idx: number) => void;
  selectedTileIdx: number;
}

const SelectLogoTiles = ({ selectedTileIdx, handleSelectStory }: SelectLogoTilesProps) => {
  const logoArray: React.JSX.Element[] = [
    <NetflixLogo
      key="netflix"
      monochrome={true}
      className={clsx(
        'w-16 md:w-28 lg:w-28 xl:w-28',
        selectedTileIdx === 0 ? 'text-text-gray-1 group-hover:text-black' : 'text-gray-3',
      )}
    />,
    <TableauLogo
      key="tableau"
      monochrome={true}
      className={clsx(
        'w-20 md:w-40 lg:w-40 xl:w-40',
        selectedTileIdx === 2 ? 'text-text-gray-1 group-hover:text-black' : 'text-gray-3',
      )}
    />,
  ];

  return (
    <div
      className="relative mt-8 flex before:absolute before:left-0 before:top-0 before:h-[3px] before:w-full before:bg-gray-5 md:mt-14 md:gap-8 lg:mt-12 lg:w-[calc(75%-3.5rem)] lg:self-end xl:mt-12 xl:w-[calc(75%-3.5rem)] xl:self-end"
      data-testid={PLAYWRIGHT_IGNORE}
    >
      {logoArray.map((logo, idx) => (
        <LogoTile key={`tile_${idx}`} idx={idx} selectedTileIdx={selectedTileIdx} handleSelectStory={handleSelectStory}>
          {logo}
        </LogoTile>
      ))}
    </div>
  );
};

export default SelectLogoTiles;
